/* eslint-disable react/react-in-jsx-scope */
import "./card-home.scss";
import {
  Card as MUICard,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import HighlightText from "./HighlightText";
import { useState } from "react";

interface CardProps {
  icon: React.ReactElement;
  title: string;
  description: string;
  onReadMore?: () => void;
}

export default function CardHome({
  icon,
  title,
  description,
  onReadMore,
}: CardProps) {
  const [showButton, setShowButton] = useState(false);

  return (
    <MUICard className="card" elevation={0}>
      <CardContent>
        <Box className="cardContent">
          <Box className="icon">{icon}</Box>

          <Typography
            variant="h6"
            className="title"
            sx={{
              mb: title === "Honoring Wishes" ? 2.9 : 0,
            }}
          >
            {title}
          </Typography>

          <Typography variant="body2" className="description">
            <HighlightText text={description} highlight={"MemorialGo"} />
          </Typography>

        {showButton && (
          <Button
            size="small"
            onClick={onReadMore}
            className="button"
            sx={{
              textTransform: "capitalize",
            }}
          >
            Read More
          </Button>
        )}
        </Box>
      </CardContent>
    </MUICard>
  );
}
